import { apiConfig } from 'config';
import { IRfidListParams } from '../@types/rfid';
import { WrapperService } from './wrapper';

export class RFIDService {
  public apiService: WrapperService = new WrapperService();

  submitRfid(values: any, isEdit?: boolean) {
    const url = `/rfid` + (isEdit ? '/' + values.id : '');
    const apiParam: any = {
      method: isEdit ? 'PATCH' : 'POST',
      url: url,
      body: values,
      baseURL: apiConfig.rfid,
      headers: {
        'content-type': 'application/merge-patch+json'
      }
    };
    if (!isEdit) {
      delete apiParam.headers;
    }
    return this.apiService.httpCall(apiParam);
  }

  getRfidCard(rfid: number) {
    const apiParam = {
      method: 'GET',
      url: `/rfid/` + rfid,
      baseURL: apiConfig.rfid
    };
    return this.apiService.httpCall(apiParam);
  }

  getRfidCards({ page = 0, size = 10, orderBy, order, ownerId, rfidNumber }: IRfidListParams) {
    const sort = `${orderBy},${order}`;

    const apiParam = {
      method: 'GET',
      params: {
        page,
        size,
        sort,
        ...(ownerId && { ownerId }),
        ...(rfidNumber && { rfidNumber })
      },
      url: `/rfid/search`,
      baseURL: apiConfig.rfid
    };
    return this.apiService.httpCall(apiParam);
  }

  /**
   * Get the rfId status per owner
   * @param ownerId based on the owner it will be the search
   */
  getRfIdStatusByOwner(ownerId: number) {
    const apiParam = {
      method: 'GET',
      url: `rfid/search?ownerId=${ownerId}`,
      baseURL: apiConfig.rfid
    };
    return this.apiService.httpCall(apiParam);
  }
  /**
   * update rfId record
   */
  updateRFID(id: number, payload: object): Promise<any> {
    const apiParam = {
      method: 'PATCH',
      url: `/rfid/${id}`,
      headers: {
        'content-type': 'application/merge-patch+json'
      },
      body: payload,
      baseURL: apiConfig.rfid
    };
    return this.apiService.httpCall(apiParam);
  }
  /**
   * update rfId record
   */
  deleteRFID(id: number): Promise<any> {
    const apiParam = {
      method: 'DELETE',
      url: `/rfid/${id}`,
      baseURL: apiConfig.rfid
    };
    return this.apiService.httpCall(apiParam);
  }
  /**
   * bulk create
   */
  bulkCreate(body: any): Promise<any> {
    const apiParam = {
      method: 'POST',
      url: `/rfid/bulk`,
      baseURL: apiConfig.rfid,
      body
    };
    return this.apiService.httpCall(apiParam);
  }
}
